<template>
  <div class="h-100 w-100">
    <div
      class="
        w-100
        d-flex
        justify-content-center
        overflow-auto
        text-center
        main-resume-container
      "
    >
      <div
        v-if="isDocType(resume)"
        class="h-100 d-flex align-items-center justify-content-center"
      >
        <div class="newCand-word-resume">
          <div class="text-center">
            <img src="../../assets/newJD/newCand-word-doc.svg" alt="" />
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div
              class="newCand-word-resume-font text-truncate"
              style="width: 85%"
            >
              {{ getFileNameFromLink(resume) }}
            </div>
            <div>
              <img
                class="mr-2"
                src="../../assets/newJD/newCand-line-icon.svg"
                alt=""
              />

              <img
                class="pointer"
                src="../../assets/newJD/newCand-download-icon.svg"
                alt=""
                @click="downloadLink(resume)"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="h-100 w-100">
        <pdf
          class="h-100 w-100 viewReseme-canvas"
          ref="pdf"
          :src="resume"
          :page="currentPage"
          @num-pages="numPages = $event"
          @link-clicked="currentPage = $event"
          @page-loaded="currentPage = $event"
        ></pdf>
      </div>
    </div>
    <div
      v-if="!isDocType(resume)"
      class="
        viewResume-paginaTion-modal
        align-items-center
        justify-content-center
        d-flex
        w-100
      "
    >
      <div class="pagination">
        <b-pagination
          align="center"
          first-number
          last-number
          v-model="currentPage"
          :total-rows="numPages"
          :per-page="perPage"
        >
          <template #prev-text>
            <span>
              <img src="../../assets/img/accessconnew/pageleft.svg" alt />
            </span>
          </template>
          <template #next-text>
            <span>
              <img src="../../assets/img/accessconnew/pageright.svg" alt />
            </span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { downloadResumeFile } from "../../utils/download.js";
export default {
  name: "Resume",
  components: {
    pdf,
  },
  props: {
    resume: String,
    candidateName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentPage: 1,
      numPages: 0,
      perPage: 1,
    };
  },
  methods: {
    async downloadLink(link) {
      await downloadResumeFile(link, this.candidateName);
    },
    isDocType(fileUrl) {
      return fileUrl == null
        ? false
        : fileUrl
            .substring(fileUrl.lastIndexOf("/") + 1)
            .split("?")[0]
            .toLowerCase()
            .endsWith(".doc") ||
            fileUrl
              .substring(fileUrl.lastIndexOf("/") + 1)
              .split("?")[0]
              .toLowerCase()
              .endsWith(".docx");
    },
    getFileNameFromLink(fileName) {
      let name = fileName
        .substring(fileName.lastIndexOf("/") + 1)
        .split("?")[0]
        .replace(/%20/g, " ");
      return decodeURIComponent(name);
    },
  },
};
</script>
<style>
.main-resume-container {
  height: calc(100vh - 305px);
}
@media (max-width: 1028px) {
  .main-resume-container {
    height: calc(100dvh - 195px);
    overflow-x: hidden !important;
    padding-top: 15px;
    overflow-y: auto !important;
  }
}
</style>
